import { render, staticRenderFns } from "./LayoutSelectSeats.vue?vue&type=template&id=55281375"
import script from "./LayoutSelectSeats.vue?vue&type=script&lang=js"
export * from "./LayoutSelectSeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports